import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconEmissions: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="emissions">
    <path d="M2 4.5a2.8 2.8 0 0 1 2.8 2.8h.002A1.6 1.6 0 0 0 6.4 8.8V7.6a.4.4 0 0 1-.4-.4 4 4 0 0 0-4-3.9z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.001 16.6h-1.56a3.001 3.001 0 0 1-5.908-.163l-.695-.347a2.6 2.6 0 0 1-.678-.49H10.1v-1.2h1.38a2.6 2.6 0 0 1-.079-.635V12.6h-1.3v-.013A1.6 1.6 0 0 1 8.704 11.1H8.7a2.3 2.3 0 0 0-2.3-2.3V7.6A3.5 3.5 0 0 1 9.897 11H9.9c0 .22.18.4.4.4h1.1v-.572c0-.69.274-1.35.762-1.838l2.828-2.829a2.6 2.6 0 0 1 1.838-.761H21v1.2h-2.4v3.3H21v1.2h-8.4v2.664c0 .53.3 1.015.774 1.252l.25.125a3.001 3.001 0 0 1 5.816.259H21zm-8.048-6.7.058-.06 2.829-2.83a1.4 1.4 0 0 1 .99-.41h.571v3.3zm3.548 7.9a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6"
    />
    <path d="M8.363 16.69A1.8 1.8 0 0 0 8.5 16a1.6 1.6 0 0 1 1.6-1.6v1.2a.4.4 0 0 0-.4.4 3 3 0 0 1-3 3H2v-1.2h4.7a1.8 1.8 0 0 0 1.663-1.11m-4.908-6.2a3.8 3.8 0 0 0-1.454-.29V9a5 5 0 0 1 5 5h-1.2a3.8 3.8 0 0 0-2.346-3.51" />
  </Icon>
);
